<template>
	<span>
		Workflow requires your attention as <b>{{ value.event.payload.workflow.assigned_to.toUpperCase() }}</b>
	</span>
</template>

<script>
export default {
	props: ['value'],
	metadata: {
		color: 'orange',
		icon: 'mdi-account-eye',
		subscription_code: 'workflow-state-require-myself'
	},
	computed: {
		custom_id() {
			return this.value.event.payload && this.value.event.payload.metadata
				? `${this.value.event.payload.metadata.custom_id} (${this.value.event.payload.metadata.content_revision_type})`
				: '';
		}
	}
};
</script>
